import { isAuthenticated } from '@/shared/lib/util/Util.tsx'
import { Navigate, Outlet } from 'react-router-dom'

const ProtectedRoute = () => {
  return isAuthenticated() ? <Outlet /> : <Navigate to="/login" replace />
}

export default ProtectedRoute
